import { operators as o, common as c } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

type AccountMetricsHoverCardAggParams = {
    name: string;
    accountId: string;
    timeSeries: c.TimeSeries;
    includeAnonymous: string;
    blacklist: c.BlacklistTypes;
};

export default {
    name: 'AccountMetricsHoverCardAggregation',
    productArea: PRODUCT_AREAS.ANALYTICS,
    subProductArea: SUB_PRODUCT_AREAS.ACCOUNT_METRICS_HOVER_CARD,
    responseFormat: 'rows',
    build: ({ name, accountId, timeSeries, includeAnonymous, blacklist }: AccountMetricsHoverCardAggParams) => {
        return buildAccountMetricsHoverCardAggregation({
            name,
            accountId,
            timeSeries,
            includeAnonymous,
            blacklist,
        });
    },
};

export function buildAccountMetricsHoverCardAggregation ({
    accountId,
    timeSeries,
    includeAnonymous,
    blacklist,
}: AccountMetricsHoverCardAggParams) {
    return o.pipeline(
        o.sources.events({ timeSeries, appId: ['expandAppIds("*")'], blacklist }),
        o.identified(includeAnonymous),
        o.filter(`accountId == "${accountId}"`),
        o.reduce({
            numVisitors: o.count('visitorId'),
            daysActive: o.count('day'),
        }),
        o.select({
            numVisitors: 'numVisitors',
            daysActive: 'daysActive',
        }),
    );
}
